import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { CommonService } from '../services/common.service';
import * as xlsx from 'xlsx';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-day-book',
  templateUrl: './day-book.component.html',
  styleUrls: ['./day-book.component.scss']
})
export class DayBookComponent implements OnInit {

  agencyData: any = [];
  jarvisData: any = [];
  search: string = '';
  curDate: any = new Date();
  month = this.curDate.getMonth();
  year = this.curDate.getFullYear();
  voucherData : any = [];
  userList: any = [];
  type = [
      {
          id: 1,
          name: 'Bank Payment'
      },
      {
          id: 2,
          name: 'Bank Receipt'
      },
      {
          id: 3,
          name: 'Cash Payment'
      },
      {
          id: 4,
          name: 'Cash Receipt'
      },
      {
          id: 5,
          name: 'Journal Voucher'
      },
      {
          id: 6,
          name: 'Purchase Voucher'
      },
      {
          id: 7,
          name: 'Sale Voucher'
      },
      {
          id: 8,
          name: 'Contra Entry'
      },
      {
          id: 9,
          name: 'Salary'
      }
  ]
  d = new Date();
  view = {
      year: this.d.getFullYear(),
      month: this.d.getMonth() + 1
  }
  months: any = [];
  monthDisplay: any;
  dateFilter = {
    showDatePicker: false
  }
  maxDate: any;
  minDate: any;
  selDate: any;
  dataSource: any = [];
  displayedColumns: string[] = ['Voucher No', 'Voucher Type', 'Credit', 'Debit', 'Amount', 'Voucher Date', 'Entered By','Entered Date',  'Updated By', 'Updated Date' ]; //'Voucher Amount'];
  exportToExcel: any = [];

  // dataSource = new MatTableDataSource();
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  // @ViewChild(MatSort) matSort!: MatSort;
  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 

  constructor(private router: Router, private apiService: APIService,private commonService: CommonService, private SpinnerLoader: NgxSpinnerService) { }

  ngOnInit(): void {
    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
    }

    let jarvis: any = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#")).reverse();
    this.monthDisplay = this.months[0].display;

    this.trasYearChange();
  }
  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }
  trasYearChange() {
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.view.year = selecetdYear[0].year;
    this.view.month = selecetdYear[0].number;
    this.resetDateFilter(0,0);
    this.getData();
  }

  getData() {
    let data = [
      {
        'month': this.view.month,
        'year': this.view.year
      },
    ];
    const myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'rpt_ACCT_DayBook',
        moduleID: 1,
        data: JSON.stringify(data),
    }];
    this.SpinnerLoader.show();
    this.apiService.getData(myParams, this.voucherDataSuccessResp.bind(this), this.voucherDataFailResp.bind(this));
  }

  voucherDataSuccessResp(res: any) {
    this.SpinnerLoader.hide();
    if(res) {
      const data = JSON.parse(res.updatePackage);
      if(data.Table[0].ErrCode != -1) {
        alert(data.Table[0].ErrMsg);
      }
      else {
        this.voucherData = data.Table1;
        this.voucherData.forEach((voucher:any) => {
          let enteredBy = this.userList.filter((x:any)=> x.UserID == voucher.CreatedUserID);
          voucher.createdBy = enteredBy.length > 0 ? enteredBy[0].Name : '-';
          let updatedBy = this.userList.filter((x:any)=> x.UserID == voucher.UpdatedUserID);
          voucher.updatedBy = updatedBy.length > 0 ? updatedBy[0].Name : '-';
          let voucherType = this.type.filter((x:any)=> x.id == voucher.VoucherTypeID);
          if(voucherType.length > 0) {
            voucher.voucherType = voucherType[0].name;
          }
          else {
            voucher.voucherType = '-';
          }
          voucher.effectiveDate = voucher.EffectiveDate ? new Date(voucher.EffectiveDate).customFormat("#DD#-#MMM#-#YY#") : '-';
          voucher.createdDT = voucher.CreatedDT ? new Date(voucher.CreatedDT).customFormat('#DD#-#MMM#-#YY#') : '-';
          voucher.createdTime = voucher.CreatedDT ? new Date(voucher.CreatedDT).customFormat('#hh#:#mm# #AMPM#') : '-'; 
          voucher.updatedDT = voucher.UpdatedDT ? new Date(voucher.UpdatedDT).customFormat("#DD#-#MMM#-#YY#") : '-';
        });

        this.dataSource = new MatTableDataSource(this.voucherData);
        this.dataSource.sort = this.matSort; 
        this.dataSource.paginator = this.paginator;
        this.exportToExcel = this.voucherData;
        if(this.view.month == this.curDate.getMonth() + 1 && this.view.year == this.curDate.getFullYear()) {
          this.selDate = new Date();
          this.dateFilter.showDatePicker = true;
          this.toggleDatepicker(this.view.month, this.view.year);
        }
      }
    }
  }

  voucherDataFailResp(res: any) {
    this.SpinnerLoader.hide();
    if(!res.error) {
      alert(res.message)
    }
  }
  //toggleDatepicker(month,year) - Date wise
	toggleDatepicker = (month: any, year:any) => {
		if (this.dateFilter.showDatePicker) {
			this.resetDateFilter(month, year);
		} else {
			this.resetDateFilter(0, 0);
		}
	}


	// Reset date filter selections
	resetDateFilter = (month: any, year: any) => {
    if (month == 0 || year == 0 || this.dateFilter.showDatePicker == false) {
      this.minDate = null;
      this.maxDate = null;
      this.selDate = null; 
      this.dateFilter.showDatePicker = false;
    } else {
      const minDT = new Date(year, month - 1, 1);
      const maxDT = new Date(year, month, 0);
      const todayDT = new Date();
      
      const adjustedMaxDT = (todayDT < maxDT) ? todayDT : maxDT;
      const selDT = (this.selDate && new Date(this.selDate) >= minDT && new Date(this.selDate) <= adjustedMaxDT) ? this.selDate : adjustedMaxDT;
  
      this.minDate = minDT;
      this.maxDate = adjustedMaxDT;
      this.selDate = new Date(selDT);
      this.dateFilter.showDatePicker = true;
    }
  
    if (this.selDate) {
      const voucherData = this.voucherData.filter((voucher: any) => {
        const voucherDate = new Date(voucher.CreatedDT).toDateString();
        const selectedDate = new Date(this.selDate).toDateString();
        return voucherDate === selectedDate;
      });
      this.dataSource = new MatTableDataSource(voucherData);
      this.exportToExcel = voucherData;
    } else {
      this.dataSource.data = this.voucherData;
      this.exportToExcel = this.voucherData;
    }
  };
  
  
  searchFilter(event: Event) {
    let searchString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = searchString.trim().toLowerCase();
    this.exportToExcel = this.dataSource.data;
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

  formatDate(date: string) {
    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear().toString().slice(-2); // Get last two digits of the year
    return `${day}-${month}-${year}`;
  }
  
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  exportToExcelActivities() {
    const reportTitle = "Day Book"
    const month = this.monthDisplay;
    const date = this.selDate;
    var html = "";
    html += "<table><tr>";
    html += "<th style='text-align: left;'>" + reportTitle + "</th>"
    html +=  "</table></tr>"; 

    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    html += "<p><b>Month : </b>" + month + "</p>";
    if (date) {
      html += "<p><b>Date : </b>" + this.formatDate(date) + "</p>";
    }
    html += "</table></tr>";

    html += "<table><tr>";

    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Voucher No.</th>";
    strHeader += "<th style='text-align: left;'>Voucher Type</th>";
    strHeader += "<th style='text-align: left;'>Credit</th>";
    strHeader += "<th style='text-align: left;'>Debit</th>";
    strHeader += "<th style='text-align: right;'>Amount(Rs.)</th>";
    strHeader += "<th style='text-align: left;'>Voucher Date</th>";
    strHeader += "<th style='text-align: left;'>Entered by</th>";
    strHeader += "<th style='text-align: left;'>Entered on</th>";
    strHeader += "<th style='text-align: left;'>Updated by</th>"
    strHeader += "<th style='text-align: left;'>Updated on</th>";
  
    strHeader += "</tr>"
    html += strHeader;

    var body = "";
    let totalAmt = 0;
    

    this.exportToExcel.forEach((item:any, key:any) => {
      let mainCrLedger = item.MainCrLedger ? (item.MainCrLedger.split('(...)')[0]) : '-';
      let mainDbLedger = item.MainDbLedger ? (item.MainDbLedger.split('(...)')[0]) : '-';
      
      body += "<tr>";
      body += "<td style='text-align: left;'>" + (item.VoucherNo ? item.VoucherNo : '-') + "</td>";
      body += "<td style='text-align: left;'>" + item.voucherType + "</td>";
      body += "<td style='text-align: left;'>" + mainCrLedger + "</td>";
      body += "<td style='text-align: left;'>" + mainDbLedger + "</td>";
      body += "<td style='text-align: right;'>" + item.CrAmt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })  + "</td>";
      body += "<td style='text-align: left;'>" + (item.EffectiveDate ? this.formatDate(item.EffectiveDate) : '-') + "</td>";
      body += "<td style='text-align: left;'>" + item.createdBy + "</td>";
      body += "<td style='text-align: left;'>" + this.formatDate(item.CreatedDT) + "</td>";
      body += "<td style='text-align: left;'>" + (item.UpdatedDT ? item.updatedBy : '-') + "</td>";
      body += "<td style='text-align: left;'>" + (item.updatedDT ? item.updatedDT : '-') + "</td>";
      body += "</tr>";

      totalAmt += Number(String(item.CrAmt).replaceAll(",", ""));
    })

    body += "<tr></tr>";
    body += "<tr>";
    body += "<td style='text-align: left; font-weight: bold;'>Grand Total</td>";
    body += "<td></td><td></td><td></td>";
    body += "<td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalAmt.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + "</td>";
    body += "</tr>";
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', reportTitle);
  }

}
